import React, { useEffect, useState } from "react";
import { GiCoalWagon } from "react-icons/gi";
import CASNavbar from "../Comps/CAS Reports/CASNavbar";
import CASBody from "../Comps/CAS Reports/CASBody";
import CustomHeading from "../Comps/Extra/CustomHeading";

const ClearanceAndSupply = () => {
  const [activePage, setActivePage] = useState("Indent Report");
  //   console.log(activePage);
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);
  return (
    <div className="newUi text-center m-1 " style={{ minHeight: "90vh" }}>
      <CustomHeading
        text={{
          heading: "Clearance And Supply",
          subText: "Clearance And Supply Management System",
        }}
        icon={GiCoalWagon}
        style={{
          height: "100px",

          // Main container
          width: "100%",
          borderRadius: "24px",
          shadow: "0 10px 30px rgba(0,0,0,0.15)",
          background: "#fff",

          // Gradient
          gradient: true,
          color: ["#490687", "#5d0abb", "#73080d"],
          gradientDirection: "120deg",

          // Heading
          headingColor: "#ffffff",
          headingSize: "clamp(2rem, 5vw, 3.5rem)",
          headingWidth: "520px",

          // Subtitle
          subtitleColor: "#f4f7fb",
          subtitleSize: "0.95rem",
          subtitleMaxWidth: "650px",
          subtitleLineHeight: 1.5,

          // Content
          contentGap: "4px",
        }}
      />
      <CASNavbar setActivePage={setActivePage} activePage={activePage} />
      <CASBody activePage={activePage} />
    </div>
  );
};

export default ClearanceAndSupply;
